const SW = 2;
const CAP = "round";
const JOIN = "round";

export function CmwHeartPlusIcon() {
  return (
    <svg viewBox="0 0 32 32" fill="none" aria-hidden>
      <path
        d="M16 26s-8-5-8-11.5a5 5 0 019-2.5 5 5 0 019 2.5C26 21 16 26 16 26z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M16 12v6M13 15h6" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

export function CmwCheckIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" aria-hidden>
      <path d="m4 8 3 3 5-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CmwRecipientIcon({ name }) {
  const cls = "cmw-icon-glyph";
  switch (name) {
    case "elderly_parent":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="17" cy="16" r="4.5" stroke="currentColor" strokeWidth={SW} />
          <circle cx="31" cy="16" r="4.5" stroke="currentColor" strokeWidth={SW} />
          <path d="M8 36c0-6 4-10 9-10s9 4 9 10" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M22 36c0-6 4-10 9-10s9 4 9 10" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "post_surgery":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <rect x="12" y="16" width="24" height="20" rx="4" stroke="currentColor" strokeWidth={SW} />
          <path d="M12 24h24" stroke="currentColor" strokeWidth={SW} />
          <path d="M24 20v8M20 24h8" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M18 12h12" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "disabled":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="24" cy="12" r="4.5" stroke="currentColor" strokeWidth={SW} />
          <path d="M24 16v8l6 6" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <circle cx="14" cy="30" r="7" stroke="currentColor" strokeWidth={SW} />
          <path d="M10 30h8M14 26v8" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "recovery_patient":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <rect x="8" y="22" width="32" height="14" rx="3" stroke="currentColor" strokeWidth={SW} />
          <path d="M8 28h32" stroke="currentColor" strokeWidth={SW} />
          <path d="M24 14v8M20 18h8" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M14 22V18M34 22V18" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    default:
      return null;
  }
}

export function CmwDurationIcon({ name }) {
  const cls = "cmw-icon-glyph";
  switch (name) {
    case "hourly":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="24" cy="24" r="13" stroke="currentColor" strokeWidth={SW} />
          <path d="M24 14v11l7 4" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "12_day":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="24" cy="24" r="8" stroke="currentColor" strokeWidth={SW} />
          <path d="M24 8v4M24 36v4M8 24h4M36 24h4M13.5 13.5l2.8 2.8M31.7 31.7l2.8 2.8M13.5 34.5l2.8-2.8M31.7 16.3l2.8-2.8" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "12_night":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <path d="M28 10a12 12 0 1012 12A9 9 0 0128 10z" stroke="currentColor" strokeWidth={SW} strokeLinejoin="round" />
          <path d="M12 14h1M14 10h1M10 18h1" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
        </svg>
      );
    case "24h":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <path d="M24 10a14 14 0 100 28 14 14 0 000-28z" stroke="currentColor" strokeWidth={SW} />
          <path d="M24 16v8h6" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <text x="24" y="27" textAnchor="middle" fill="currentColor" fontSize="9" fontWeight="800">24</text>
        </svg>
      );
    default:
      return null;
  }
}

export function CmwServiceIcon({ name }) {
  const cls = "cmw-icon-glyph cmw-icon-glyph--service";
  switch (name) {
    case "attendant":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="24" cy="15" r="5" stroke="currentColor" strokeWidth={SW} />
          <path d="M12 40v-2c0-5.5 5.4-10 12-10s12 4.5 12 10v2" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M30 28c2-2 4-3 6-3" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "nurses":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <rect x="14" y="18" width="20" height="18" rx="3" stroke="currentColor" strokeWidth={SW} />
          <path d="M20 18v-4h8v4" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M24 24v8M20 28h8" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "physio":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="18" cy="16" r="4" stroke="currentColor" strokeWidth={SW} />
          <path d="M14 32c1-6 3-9 4-9s3 3 4 9" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <circle cx="32" cy="17" r="3.5" stroke="currentColor" strokeWidth={SW} />
          <path d="M28 32c.8-5 2-7.5 4-7.5s3.2 2.5 4 7.5" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M30 24l4 4" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "dementia":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="22" cy="18" r="8" stroke="currentColor" strokeWidth={SW} />
          <path d="M12 38c2-10 8-14 10-14s8 4 10 14" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M30 16h4v4h4v4h-4v4h-4v-4h-4v-4h4v-4z" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
        </svg>
      );
    case "post_operative":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <path d="M12 20a12 12 0 0124 0" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M10 20v4a14 14 0 0028 0v-4" stroke="currentColor" strokeWidth={SW} />
          <circle cx="34" cy="32" r="5" stroke="currentColor" strokeWidth={SW} />
          <path d="M34 29v6M31 32h6" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
        </svg>
      );
    case "elder_companion":
      return (
        <svg className={cls} viewBox="0 0 48 48" fill="none" aria-hidden>
          <circle cx="17" cy="16" r="4" stroke="currentColor" strokeWidth={SW} />
          <circle cx="31" cy="16" r="4" stroke="currentColor" strokeWidth={SW} />
          <path d="M8 36c0-5 4-9 9-9s9 4 9 9" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M22 36c0-5 4-9 9-9s9 4 9 9" stroke="currentColor" strokeWidth={SW} strokeLinecap="round" />
          <path d="M24 30s-2-1.5-2-3a2 2 0 014 0c0 1.5-2 3-2 3z" stroke="currentColor" strokeWidth="1.75" />
        </svg>
      );
    default:
      return null;
  }
}

export function CmwTrustShieldIcon({ tone = "blue" }) {
  const fill = tone === "green" ? "#22c55e" : "#1e5bff";
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill={fill} />
      <path d="m9 12 2 2 4-4" stroke="#fff" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CmwMedicalIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <rect x="4" y="8" width="16" height="12" rx="2" fill="#22c55e" />
      <path d="M12 11v6M9 14h6" stroke="#fff" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}
